module.exports = __webpack_public_path__ + "static/media/clock-1.ebcc9970.svg";